.circleCheckboxWrapper {
  display: flex;
  position: relative;
}
.circleCheckboxInput {
  top: 0;
  left: 0;
  cursor: inherit;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  padding: 0;
  z-index: 1;
  position: absolute;
}
.circleCheckboxIcon {
  fill: currentColor;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-size: 1.5rem;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  flex-shrink: 0;
  user-select: none;
}
